import { render, staticRenderFns } from "./ProviderOptionCard.vue?vue&type=template&id=2a434552&scoped=true&"
import script from "./ProviderOptionCard.vue?vue&type=script&lang=js&"
export * from "./ProviderOptionCard.vue?vue&type=script&lang=js&"
import style0 from "./ProviderOptionCard.vue?vue&type=style&index=0&id=2a434552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a434552",
  null
  
)

export default component.exports